import { Link, Navigate } from "react-router-dom";
import { Logo, ThemeToggle } from "@/components/common";
import { useAuth, homeFor } from "@/context/AuthContext";
import Login from "@/pages/public/Login";

export default function AuthPage({ console: isConsole = false }) {
  const { me } = useAuth();
  if (me && isConsole && me.permissions?.includes("console:access")) return <Navigate to="/console" replace />;
  if (me && !isConsole) return <Navigate to={homeFor(me)} replace />;
  return (
    <div className="min-h-screen flex flex-col mr-grid-bg" data-testid={isConsole ? "console-login-page" : "member-login-page"}>
      <header className="flex items-center justify-between px-5 sm:px-8 h-16">
        <Logo to={isConsole ? "/console/connexion" : "/"} testId="auth-logo-link" />
        <ThemeToggle />
      </header>
      <main className="flex-1 grid place-items-center"><div className="w-full"><Login console={isConsole} /></div></main>
      {!isConsole && <footer className="text-center text-xs text-mr-muted pb-6"><Link to="/" data-testid="auth-site-link" className="hover:text-mr-text">Retour au site</Link></footer>}
    </div>
  );
}
